
/* eslint-disable */
export enum jobDetailsLocalisationKeys {
  SOME_ISSUES = 'SOME_ISSUES',
  SOME_ERRORS = 'SOME_ERRORS',
  UNAFFECTED_RESERVATION = 'UNAFFECTED_RESERVATION',
  DATA_IS_NEEDED = 'DATA_IS_NEEDED',
  DELETE_THIS_UPLOAD = 'DELETE_THIS_UPLOAD',
  CORRECT_THE_DATA = 'CORRECT_THE_DATA',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  ROW = 'ROW',
  LOCATION = 'LOCATION',
  START_END_TIME = 'START_END_TIME',
  ISSUE_FOUND = 'ISSUE_FOUND',
  NUMBER_ISSUES = 'NUMBER_ISSUES',
  NUMBER_ERRORS = 'NUMBER_ERRORS',
  RESERVATION_UPLOADS = 'RESERVATION_UPLOADS',
  DELETE_RESERVATION_UPLOAD = 'DELETE_RESERVATION_UPLOAD',
  HEADS_UP = 'HEADS_UP',
  RE_UPLOAD = 'RE_UPLOAD',
  DELETE_ME = 'DELETE_ME',
  TYPE_DELETE_ME = 'TYPE_DELETE_ME',
  CANCEL = 'CANCEL',
  DELETE = 'DELETE',
  NOT_VALID_CONFIRM_TEXT = 'NOT_VALID_CONFIRM_TEXT',
  DELETE_THIS_RESERVATION_UPLOAD = 'DELETE_THIS_RESERVATION_UPLOAD',
  TEXT_CONFIRM_FOR_DELETE = 'TEXT_CONFIRM_FOR_DELETE',
  UPLOADED_ON = 'UPLOADED_ON',
  PROJECT_NOT_FOUND = 'PROJECT_NOT_FOUND',
  MAX_ISSUES_SHOWN = 'MAX_ISSUES_SHOWN'
}

export type IJobDetailsTranslation = jobDetailsLocalisationKeys.SOME_ISSUES | jobDetailsLocalisationKeys.SOME_ERRORS

export const enJobDetailsLocalisationMessages = {
  [jobDetailsLocalisationKeys.SOME_ISSUES]: `We found some issues in your upload.`,
  [jobDetailsLocalisationKeys.SOME_ERRORS]: `We found some errors in your upload.`,
  [jobDetailsLocalisationKeys.UNAFFECTED_RESERVATION]: `All unaffected reservations have been uploaded, but the following items were omitted.`,
  [jobDetailsLocalisationKeys.DATA_IS_NEEDED]: `If this data is needed, you can `,
  [jobDetailsLocalisationKeys.DELETE_THIS_UPLOAD]: `delete this upload, `,
  [jobDetailsLocalisationKeys.CORRECT_THE_DATA]: `correct the data and upload it again.`,
  [jobDetailsLocalisationKeys.SUCCESS]: `Success `,
  [jobDetailsLocalisationKeys.FAILED]: `Failed `,
  [jobDetailsLocalisationKeys.ROW]: `Row`,
  [jobDetailsLocalisationKeys.LOCATION]: `Location`,
  [jobDetailsLocalisationKeys.START_END_TIME]: `Start/end time`,
  [jobDetailsLocalisationKeys.ISSUE_FOUND]: `Issue found`,
  [jobDetailsLocalisationKeys.NUMBER_ISSUES]: ` issues`,
  [jobDetailsLocalisationKeys.NUMBER_ERRORS]: ` errors`,
  [jobDetailsLocalisationKeys.RESERVATION_UPLOADS]: `Reservation Uploads`,
  [jobDetailsLocalisationKeys.DELETE_RESERVATION_UPLOAD]: `Delete this Reservation Upload`,
  [jobDetailsLocalisationKeys.HEADS_UP]: `Heads up! This action cannot be reversed.`,
  [jobDetailsLocalisationKeys.RE_UPLOAD]: `If you need this reservation data in the future, you must re-upload the original file.`,
  [jobDetailsLocalisationKeys.DELETE_ME]: `To delete this data, type "DELETE ME" in the box below.`,
  [jobDetailsLocalisationKeys.TYPE_DELETE_ME]: `Type "DELETE ME" here`,
  [jobDetailsLocalisationKeys.CANCEL]: `Cancel`,
  [jobDetailsLocalisationKeys.DELETE]: `Delete`,
  [jobDetailsLocalisationKeys.NOT_VALID_CONFIRM_TEXT]: `The text entered is incorrect`,
  [jobDetailsLocalisationKeys.DELETE_THIS_RESERVATION_UPLOAD]: `Delete this reservation upload`,
  [jobDetailsLocalisationKeys.TEXT_CONFIRM_FOR_DELETE]: `DELETE ME`,
  [jobDetailsLocalisationKeys.PROCESSING]: `Processing ...`,
  [jobDetailsLocalisationKeys.UPLOADED_ON]: `Uploaded on`,
  [jobDetailsLocalisationKeys.PROJECT_NOT_FOUND]: `Project not found`,
  [jobDetailsLocalisationKeys.MAX_ISSUES_SHOWN]: `more issues not displayed`
}
